module.exports = __webpack_public_path__ + "img/address_icon.022c1b1e.png";